import loadImage from "./loadImage";

const Img = (props: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => {
  loadImage(props.src).read();
  return <img {...props} loading="lazy" />;
};

export default Img;
